import { useCreateAdminAxiosInstance } from "./useCreateAdminAxiosInstance.ts";

export function useCreateSpeakingClassServiceAdminAxiosInstance() {
  return useCreateAdminAxiosInstance(
    import.meta.env.VITE_SPEAKING_CLASS_SERVICE_BASE_URL,
  );
}
